import React, { useState } from 'react';
import { Col, Row } from 'components/Core/Grid';
import Button from 'components/Core/Button';
import WistiaVideo from 'components/Core/WistiaVideo';
import useBreakpointView from 'utils/useBreakpointView';

import VideoTheaterContainer from './styles';

const VideoTheater = ({ entries }) => {
  const [currentVideo, setCurrentVideo] = useState(0);
  const isMobile = useBreakpointView(['xs', 'sm']);

  const videoData = {};

  entries.forEach((entry) => {
    const type = entry?.templateId?.split('-')?.[0];
    const num = entry?.templateId?.split('-')?.[1];
    const value = JSON.parse(entry.content.raw)?.content?.[0]?.content?.[0]?.value;
    const key = `video${num}`;

    videoData[key] = {
      ...videoData[key],
      [type]: value,
    };
  });

  const allVideos = Object.keys(videoData).map((key) => videoData[key]);

  const onVideoClick = (index) => {
    setCurrentVideo(index);
  };

  const onNextVideoClick = () => {
    let curIndex = currentVideo;

    curIndex = (curIndex + 1) % allVideos.length;

    if (curIndex >= 3) curIndex = 0;

    setCurrentVideo(curIndex);
  };

  return (
    <VideoTheaterContainer>
      <div className="section-thankyou-hero">
        <div className="section-thankyou-hero--header">
          <h2 className="section-thankyou-hero--title">Learn more about ServiceTitan.</h2>
          <Button
            className="section-thankyou-hero--next-button desktop-view"
            type="secondary"
            onClick={onNextVideoClick}
          >
            Next Video
          </Button>
        </div>
        <Row className="section-thankyou-hero--main-content">
          <Col xs={24} lg={14} xl={16}>
            {allVideos?.map((video, index) => {
              return (
                <WistiaVideo
                  wrapperClass={currentVideo === index ? 'active' : 'inactive'}
                  autoPlay={!isMobile}
                  dataPosition="Hero"
                  id="thankyou_main"
                  inline
                  url={video.videoUrl}
                  initial={index === 0}
                  active={currentVideo === index}
                />
              );
            })}
          </Col>
          <Col xs={24} lg={10} xl={8}>
            <div className="section-thankyou-hero--main-text">
              <h2 className="section-thankyou-hero--main-title">
                {allVideos[currentVideo]?.title}
              </h2>
              <p className="section-thankyou-hero--main-description">
                {allVideos[currentVideo]?.description}
              </p>
            </div>
          </Col>
        </Row>

        <Row gutter={40} className="section-thankyou-hero--video-list">
          {allVideos.map((item, index) => {
            return (
              <Col key={index} onClick={() => onVideoClick(index)} xs={24} sm={8}>
                <div
                  className={`section-thankyou-hero--video-item
                    ${currentVideo === index ? ' current-playing' : ''}`}
                >
                  <div className="section-thankyou-hero--video-item-video-cover">
                    {item.videoUrl ? (
                      <WistiaVideo
                        dataPosition="Hero"
                        fullWidth
                        id={`preview-${index}`}
                        thumbnailOnly
                        url={item.videoUrl}
                        inline
                        mode="carousel"
                      />
                    ) : null}
                    <div className="section-thankyou-hero--video-item-video-overlay" />
                    <p className="section-thankyou-hero--item-now-playing">Now Playing</p>
                  </div>
                  <div className="section-thankyou-hero--video-item-text-cover">
                    <h2 className="section-thankyou-hero--video-item-title">{item.title}</h2>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    </VideoTheaterContainer>
  );
};

export default VideoTheater;
